import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useSearchParams } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Stats from './components/Stats';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';
import PlaquetteModal from './components/PlaquetteModal';
import ThankYou from './pages/ThankYou';
import './App.css';

// Page d'accueil
function HomePage({ onContactClick, onPlaquetteClick }) {
  return (
    <>
      <main>
        <Hero onPlaquetteClick={onPlaquetteClick} onContactClick={onContactClick} />
        <Features />
        <HowItWorks />
        <Stats />
        <Contact />
      </main>
    </>
  );
}

// Composant principal avec gestion du token personnalisé
function MainContent() {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showPlaquetteModal, setShowPlaquetteModal] = useState(false);
  const [customTokenData, setCustomTokenData] = useState(null);
  const [tokenError, setTokenError] = useState(null);
  const [tokenLoading, setTokenLoading] = useState(false);
  const [searchParams] = useSearchParams();

  // Détecter et valider le token personnalisé au chargement
  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      setTokenLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
      
      fetch(`${backendUrl}/demo-leads/custom-purchase-token/${token}`)
        .then(res => res.json())
        .then(data => {
          if (data.result && data.data) {
            // Token valide - stocker les données et ouvrir le modal
            setCustomTokenData({
              token,
              ...data.data,
            });
            setShowContactModal(true);
          } else {
            // Token invalide ou expiré
            setTokenError(data.message || 'Ce lien n\'est plus valide');
          }
        })
        .catch(err => {
          console.error('Erreur validation token:', err);
          setTokenError('Erreur de connexion au serveur');
        })
        .finally(() => {
          setTokenLoading(false);
        });
    }
  }, [searchParams]);

  // Fermer le modal et nettoyer l'URL
  const handleCloseModal = () => {
    setShowContactModal(false);
    // Nettoyer le token de l'URL sans recharger la page
    if (searchParams.get('token')) {
      window.history.replaceState({}, '', window.location.pathname);
      setCustomTokenData(null);
    }
  };

  return (
    <>
      <Header onContactClick={() => setShowContactModal(true)} />
      <HomePage 
        onContactClick={() => setShowContactModal(true)} 
        onPlaquetteClick={() => setShowPlaquetteModal(true)} 
      />
      <Footer onPlaquetteClick={() => setShowPlaquetteModal(true)} />
      
      {/* Loader pendant la validation du token */}
      {tokenLoading && (
        <div className="token-loading-overlay">
          <div className="token-loading-spinner" />
          <p>Chargement de votre offre...</p>
        </div>
      )}
      
      {/* Erreur de token */}
      {tokenError && (
        <div className="token-error-overlay" onClick={() => setTokenError(null)}>
          <div className="token-error-modal" onClick={e => e.stopPropagation()}>
            <h3>Lien invalide</h3>
            <p>{tokenError}</p>
            <button onClick={() => setTokenError(null)}>Fermer</button>
          </div>
        </div>
      )}
      
      {/* Modal de contact */}
      <ContactModal 
        isOpen={showContactModal} 
        onClose={handleCloseModal}
        customTokenData={customTokenData}
      />
      
      {/* Modal plaquette */}
      <PlaquetteModal 
        isOpen={showPlaquetteModal} 
        onClose={() => setShowPlaquetteModal(false)} 
      />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Page de remerciement après paiement */}
          <Route path="/merci" element={<ThankYou />} />
          
          {/* Page d'accueil (avec gestion du token) */}
          <Route path="*" element={<MainContent />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
